import SpotAssets from "./index";

export default { path: "/home/orderLimit/spotAssets", component: SpotAssets };
